module.exports = __webpack_public_path__ + "static/media/stopButton.0d5d973a.svg";